<mat-accordion>
  <!-- always have the first detail information card expanded until the user opens another one -->
  @if (!roomExaminationService.getRoomIsClosed()) {
  <mat-expansion-panel [(expanded)]="detailInformationPanelExpanded">
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.room-examination.detail-information" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-key-value-table [keyValues]="keyValues"></app-key-value-table>
  </mat-expansion-panel>
  }
  @if (!roomExaminationService.isSelfCreatedRoom()) {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (
        roomExaminationService.errorListServiceRoomNotVisited.errors$
        | async;
        as errors
        ) {
        <div>
          @if (errors.length > 0) {
          <mat-icon class="error-icon">warning</mat-icon>
          }
        </div>
        }
        {{
        "components.room-examination.room-examination-not-possible"
        | translate
        }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-room-not-visited></app-room-not-visited>
  </mat-expansion-panel>
  }
  @if (!roomExaminationService.getRoomIsClosed()) {
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        @if (
        roomExaminationService.errorListServiceTariffSelection.errors$
        | async;
        as errors
        ) {
        <div>
          @if (errors.length > 0) {
          <mat-icon class="error-icon">warning</mat-icon>
          }
        </div>
        }
        {{ "components.room-examination.tariffs" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-tariff-selection></app-tariff-selection>
  </mat-expansion-panel>
  }
  <mat-expansion-panel #photoPanel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{ "components.room-examination.pictures" | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <app-upload-pictures [isActive]="photoPanel.expanded"></app-upload-pictures>
  </mat-expansion-panel>
</mat-accordion>